import { render, staticRenderFns } from "./AddSeafarerWithPersonalCode.vue?vue&type=template&id=19d444fe"
import script from "./AddSeafarerWithPersonalCode.vue?vue&type=script&lang=ts"
export * from "./AddSeafarerWithPersonalCode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports